import { useDialog } from '@dni-hooks/useDialog'
import { Button } from '@pets-ui/Button/Button'
import { Dialog } from '@pets-ui/Dialog/Dialog'
import { DialogActions } from '@pets-ui/DialogActions/DialogActions'
import { DialogContent } from '@pets-ui/DialogContent/DialogContent'
import { DialogHeader } from '@pets-ui/DialogHeader/DialogHeader'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import * as stylex from '@stylexjs/stylex'

const styles = stylex.create({
  content: {
    paddingBlock: '12px',
  },
  button: {
    backgroundColor: colors.black,
    width: '100%',
  },
})

export const DIALOG_AI_CHECK_DELIVERY_CLASS = 'DIALOG_AI_CHECK_DELIVERY_CLASS'

export const DialogAiCheckDeliveryClass = () => {
  const { open, closeDialog } = useDialog(DIALOG_AI_CHECK_DELIVERY_CLASS)

  return (
    <Dialog open={open} maxWidth={320}>
      <DialogHeader title="無法執行本操作" onClose={closeDialog} />
      <DialogContent rootStyle={styles.content}>
        <Text variant="body" color={colors.grey800}>冷凍商品需要單獨結帳，目前品項包含常溫與冷凍商品。</Text>
      </DialogContent>
      <DialogActions display="flex">
        <Button rootStyle={styles.button} onClick={closeDialog}>確定</Button>
      </DialogActions>
    </Dialog>
  )
}
